"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6893],{

/***/ 8272:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_EmptyStore; }
});

// EXTERNAL MODULE: ./lib/utils.js
var utils = __webpack_require__(7756);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/illustrations/Smiley.jsx



var Smiley = function Smiley(_ref) {
  var className = _ref.className,
      color = _ref.color;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "50",
    height: "51",
    className: className,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M25 0.0273438C38.7851 0.0273438 50 11.2423 50 25.0273C50 38.8124 38.7851 50.0273 25 50.0273C11.2149 50.0273 0 38.8124 0 25.0273C1.41389e-05 11.2423 11.2149 0.0273579 25 0.0273438ZM25 2.50781C12.5823 2.50787 2.47955 12.6106 2.47949 25.0283C2.47949 37.4461 12.5819 47.5488 25 47.5488C37.4178 47.5488 47.5205 37.4461 47.5205 25.0283C47.5205 12.6106 37.4177 2.50781 25 2.50781Z",
      fill: color
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M38.792 19.553C38.792 21.7352 37.0228 23.5045 34.8401 23.5045C32.6579 23.5045 30.8887 21.7352 30.8887 19.553C30.8887 17.3708 32.6579 15.6016 34.8401 15.6016C37.0228 15.6016 38.792 17.3708 38.792 19.553Z",
      fill: color
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M19.1114 19.553C19.1114 21.7352 17.3421 23.5045 15.1599 23.5045C12.9772 23.5045 11.208 21.7352 11.208 19.553C11.208 17.3708 12.9772 15.6016 15.1599 15.6016C17.3421 15.6016 19.1114 17.3708 19.1114 19.553Z",
      fill: color
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M32.3609 32.0313C31.0776 32.0313 30.3685 32.4844 29.8509 32.816C29.454 33.0694 29.2361 33.2095 28.6783 33.2095C28.1205 33.2095 27.9017 33.0694 27.5048 32.816C26.9872 32.4848 26.2781 32.0313 24.9948 32.0313C23.7124 32.0313 23.0038 32.4844 22.4871 32.816C22.0901 33.0694 21.8727 33.2095 21.3149 33.2095C20.7588 33.2095 20.5405 33.0698 20.1453 32.8164C19.6282 32.4852 18.92 32.0317 17.638 32.0317C16.9536 32.0317 16.3984 32.5873 16.3984 33.2713C16.3984 33.9557 16.954 34.5109 17.638 34.5109C18.1941 34.5109 18.4124 34.6505 18.8076 34.9039C19.3247 35.2351 20.0329 35.6887 21.3149 35.6887C22.5982 35.6887 23.3064 35.2351 23.8235 34.9039C24.2204 34.6505 24.4379 34.5109 24.9953 34.5109C25.553 34.5109 25.7718 34.651 26.1688 34.9043C26.6863 35.2356 27.3954 35.6891 28.6787 35.6891C29.9612 35.6891 30.6702 35.236 31.1878 34.9043C31.5847 34.651 31.8027 34.5109 32.3613 34.5109C33.0458 34.5109 33.6009 33.9553 33.6009 33.2713C33.6005 32.5873 33.0453 32.0312 32.3609 32.0312V32.0313Z",
      fill: color
    })]
  });
};

/* harmony default export */ var illustrations_Smiley = (Smiley);
;// CONCATENATED MODULE: ./components/EmptyStore.jsx






var EmptyStore = function EmptyStore(_ref) {
  var _store$store, _store$store2, _store$store2$contact;

  var store = _ref.store,
      _ref$search = _ref.search,
      search = _ref$search === void 0 ? false : _ref$search,
      _ref$searchQuery = _ref.searchQuery,
      searchQuery = _ref$searchQuery === void 0 ? "" : _ref$searchQuery;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (0,utils.cn)("flex w-full items-center justify-center", search && "items-start", !search && "flex-col"),
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "mt-[10vh] flex w-[calc(var(--max-width)-200px)] flex-col items-center justify-center",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(illustrations_Smiley, {
        className: "mt-12 size-[96px]",
        color: "var(--font-background)"
      }), search ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "mt-4 text-center text-[20px] italic leading-[1.5] text-fontBackground",
        children: ["Looks like we don\u2019t have ", /*#__PURE__*/(0,jsx_runtime.jsx)("b", {
          children: searchQuery
        }), ".", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Check the spelling or try a different item."]
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "mt-5 text-center text-[28px] font-bold text-fontBackground",
          children: "Oh deer, it\u2019s empty!"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "mt-2 text-center text-[16px] italic leading-[1.5] text-fontBackground",
          children: [store === null || store === void 0 ? void 0 : (_store$store = store.store) === null || _store$store === void 0 ? void 0 : _store$store.storeName, " haven't added any", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " products to their shop yet.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " If you'd like to see them here, we'd", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " love for you to drop them an invite."]
        })]
      })]
    }), !search && /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      href: "instagram://user?username=".concat(store === null || store === void 0 ? void 0 : (_store$store2 = store.store) === null || _store$store2 === void 0 ? void 0 : (_store$store2$contact = _store$store2.contactInfo) === null || _store$store2$contact === void 0 ? void 0 : _store$store2$contact.instagramHandle),
      className: "mt-6 rounded-lg border border-primary bg-primary px-14 py-2.5 text-fontPrimary hover:cursor-pointer",
      children: "INVITE"
    })]
  });
};

/* harmony default export */ var components_EmptyStore = (EmptyStore);

/***/ }),

/***/ 7861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
 // eslint-disable-next-line no-undef



var _require = __webpack_require__(6006),
    WindowVirtualizer = _require.WindowVirtualizer,
    Virtualizer = _require.Virtualizer; // --- SessionStorage Availability Check ---


function isSessionStorageAvailable() {
  try {
    if ( false || typeof window.sessionStorage === "undefined") {
      return false;
    }

    var testKey = "__restorable_list_test__";
    window.sessionStorage.setItem(testKey, testKey);
    window.sessionStorage.removeItem(testKey);
    return true;
  } catch (e) {
    console.warn("SessionStorage is not available or accessible: ".concat(e.message));
    return false;
  }
}

var RestorableList = function RestorableList(_ref) {
  var children = _ref.children,
      _ref$useVirtualizer = _ref.useVirtualizer,
      useVirtualizer = _ref$useVirtualizer === void 0 ? false : _ref$useVirtualizer;
  var cacheKey = "window-list-cache-1";
  var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null); // Check if sessionStorage is available

  var isSessionStorageAvailable = function isSessionStorageAvailable() {
    try {
      var testKey = "__storage_test__";
      window.sessionStorage.setItem(testKey, testKey);
      window.sessionStorage.removeItem(testKey);
      return true;
    } catch (e) {
      console.warn("sessionStorage not available:", e);
      return false;
    }
  }; // Safe sessionStorage getter


  var safeGetItem = function safeGetItem(key) {
    try {
      if (isSessionStorageAvailable()) {
        var _window, _window$sessionStorag;

        return (_window = window) === null || _window === void 0 ? void 0 : (_window$sessionStorag = _window.sessionStorage) === null || _window$sessionStorag === void 0 ? void 0 : _window$sessionStorag.getItem(key);
      }

      return null;
    } catch (e) {
      console.warn("Error accessing sessionStorage:", e);
      return null;
    }
  }; // Safe sessionStorage setter


  var safeSetItem = function safeSetItem(key, value) {
    try {
      if (isSessionStorageAvailable()) {
        var _window2, _window2$sessionStora;

        (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$sessionStora = _window2.sessionStorage) === null || _window2$sessionStora === void 0 ? void 0 : _window2$sessionStora.setItem(key, value);
      }
    } catch (e) {
      console.warn("Error setting sessionStorage:", e);
    }
  }; // Safe sessionStorage remover


  var safeRemoveItem = function safeRemoveItem(key) {
    try {
      if (isSessionStorageAvailable()) {
        var _window3, _window3$sessionStora;

        (_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$sessionStora = _window3.sessionStorage) === null || _window3$sessionStora === void 0 ? void 0 : _window3$sessionStora.removeItem(key);
      }
    } catch (e) {
      console.warn("Error removing from sessionStorage:", e);
    }
  }; // Add error handling for ResizeObserver


  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var handleError = function handleError(error) {
      if (error.message.includes("ResizeObserver")) {
        error.stopPropagation();
        return false;
      }
    };

    window.addEventListener("error", handleError);
    return function () {
      return window.removeEventListener("error", handleError);
    };
  }, []);

  var _useMemo = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    var serialized;
    serialized = safeGetItem(cacheKey);
    if (!serialized) return [];

    try {
      return JSON.parse(serialized); // eslint-disable-next-line no-unused-vars
    } catch (e) {
      return [];
    }
  }, []),
      offset = _useMemo[0],
      cache = _useMemo[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(function () {
    if (!ref.current) return;
    var handle = ref.current;
    window.scrollTo(0, offset !== null && offset !== void 0 ? offset : 0);
    safeRemoveItem(cacheKey);
    var scrollY = 0;

    var onScroll = function onScroll() {
      scrollY = window.scrollY;
    };

    window.addEventListener("beforeunload", function () {
      safeRemoveItem(cacheKey);
    });
    window.addEventListener("scroll", onScroll);
    onScroll();
    return function () {
      window.removeEventListener("scroll", onScroll); // Use stored window.scrollY because it may return 0 in useEffect cleanup

      safeSetItem(cacheKey, JSON.stringify([scrollY, handle.cache]));
    };
  }, [offset]);

  if (useVirtualizer) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Virtualizer, {
      children: children
    });
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(WindowVirtualizer, {
    ref: ref,
    cache: cache,
    children: children
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (RestorableList);

/***/ }),

/***/ 2463:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ Skeleton; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5258);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3855);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7756);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);


var _excluded = ["className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




function Skeleton(_ref) {
  var className = _ref.className,
      props = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", _objectSpread({
    className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_3__.cn)("animate-pulse rounded-md bg-[#e8eaf6]", className)
  }, props));
}



/***/ }),

/***/ 3101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7756);
/* harmony import */ var _Skeleton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2463);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);






var SkeletonCard = function SkeletonCard(_ref) {
  var _ref$imageClass = _ref.imageClass,
      imageClass = _ref$imageClass === void 0 ? "" : _ref$imageClass,
      _ref$titleClass = _ref.titleClass,
      titleClass = _ref$titleClass === void 0 ? "" : _ref$titleClass,
      _ref$descriptionClass = _ref.descriptionClass,
      descriptionClass = _ref$descriptionClass === void 0 ? "" : _ref$descriptionClass,
      _ref$containerClass = _ref.containerClass,
      containerClass = _ref$containerClass === void 0 ? "" : _ref$containerClass;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
    className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_3__.cn)("flex flex-col space-y-3", containerClass),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_Skeleton__WEBPACK_IMPORTED_MODULE_1__/* .Skeleton */ .O, {
      className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_3__.cn)("h-[125px] w-[250px] rounded-xl", imageClass)
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
      className: "space-y-2",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_Skeleton__WEBPACK_IMPORTED_MODULE_1__/* .Skeleton */ .O, {
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_3__.cn)("h-4 w-[250px]", titleClass)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_Skeleton__WEBPACK_IMPORTED_MODULE_1__/* .Skeleton */ .O, {
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_3__.cn)("h-4 w-[200px]", descriptionClass)
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (SkeletonCard);

/***/ }),

/***/ 2141:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_StoreItem; }
});

// EXTERNAL MODULE: ./node_modules/lottie-react/build/index.umd.js
var index_umd = __webpack_require__(9260);
var index_umd_default = /*#__PURE__*/__webpack_require__.n(index_umd);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-lazy-load-image-component/build/index.js
var build = __webpack_require__(2679);
// EXTERNAL MODULE: ./node_modules/react-lines-ellipsis/lib/index.js
var lib = __webpack_require__(7878);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./store/search-store.js
var search_store = __webpack_require__(1401);
;// CONCATENATED MODULE: ./components/shimmer.json
var shimmer_namespaceObject = JSON.parse('{"v":"5.5.7","meta":{"g":"LottieFiles AE 0.1.20","a":"Randy Varianda","k":"","d":"","tc":""},"fr":16,"ip":0,"op":32,"w":128,"h":128,"nm":"Lazy Load","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Shape Layer 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":0,"s":[-11.5,49,0],"to":[36.083,9.667,0],"ti":[-0.25,-0.083,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.333,"y":0},"t":40,"s":[204.99999999999997,107,0],"to":[0.25,0.083,0],"ti":[35.833,9.583,0]},{"t":59,"s":[-10,49.5,0]}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[179.208,93.896,100],"ix":6}},"ao":0,"ef":[{"ty":29,"nm":"Gaussian Blur","np":5,"mn":"ADBE Gaussian Blur 2","ix":1,"en":1,"ef":[{"ty":0,"nm":"Blurriness","mn":"ADBE Gaussian Blur 2-0001","ix":1,"v":{"a":0,"k":34.3,"ix":1}},{"ty":7,"nm":"Blur Dimensions","mn":"ADBE Gaussian Blur 2-0002","ix":2,"v":{"a":0,"k":1,"ix":2}},{"ty":7,"nm":"Repeat Edge Pixels","mn":"ADBE Gaussian Blur 2-0003","ix":3,"v":{"a":0,"k":0,"ix":3}}]}],"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[7.721,144.227],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"fl","c":{"a":0,"k":[0.7294117647058823,0.7490196078431373,0.8666666666666667,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[-18.46,3.373],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,146.624],"ix":3},"r":{"a":0,"k":20.495,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":40,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"Shape Layer 1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[62.458000000000006,55.823,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[120.328,77.977],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"fl","c":{"a":0,"k":[0.9098039215686274,0.9176470588235294,0.9647058823529412,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[1.542,8.177],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[109.644,176.784],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":40,"st":0,"bm":0}],"markers":[]}');
var components_shimmer_namespaceObject = /*#__PURE__*/__webpack_require__.t(shimmer_namespaceObject, 2);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/StoreItem.jsx
// import dynamic from "next/dynamic";
// const Lottie = dynamic(() => import("lottie-react"), { ssr: false });






 // Browser-compatible path parsing





var parseFileName = function parseFileName(url) {
  if (!url) return "";
  var parts = url.split("/");
  var filename = parts[parts.length - 1].split("?")[0];
  return {
    name: filename.substring(0, filename.lastIndexOf(".")),
    ext: filename.substring(filename.lastIndexOf("."))
  };
};

var StoreItem = function StoreItem(_ref) {
  var usedForCollectionhome = _ref.usedForCollectionhome,
      product = _ref.product,
      cohort = _ref.cohort,
      toggleDrawer = _ref.toggleDrawer,
      search = _ref.search;

  var _useState = (0,react.useState)(false),
      imageLoaded = _useState[0],
      setImageLoaded = _useState[1];

  var _useState2 = (0,react.useState)(false),
      fallbackSet = _useState2[0],
      setFallbackSet = _useState2[1];

  var _useState3 = (0,react.useState)(null),
      imageName = _useState3[0],
      setImageName = _useState3[1];

  var _useStore = (0,search_store/* default */.Z)(function (state) {
    return {
      setShouldSearchReopen: state.setShouldSearchReopen
    };
  }),
      setShouldSearchReopen = _useStore.setShouldSearchReopen;

  var router = (0,next_router.useRouter)();

  var getProductPrice = function getProductPrice(price) {
    var mrp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    if (!price) return;

    if (mrp) {
      var strikeOutMRP = /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "text-sm font-light line-through opacity-60",
        children: "".concat(String.fromCharCode(0x20b9)).concat(mrp)
      });

      return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: ["".concat(String.fromCharCode(0x20b9)).concat(price), " ", strikeOutMRP]
      });
    } else {
      return "".concat(String.fromCharCode(0x20b9)).concat(product.price);
    }
  };

  var getImageUrl = function getImageUrl() {
    if (!imageName) return "";
    var imageurl = "";

    if (product.productPhotos && product.productPhotos[0]) {
      if (product.productPhotos[0].includes("dm2buy")) {
        imageurl = "https://dm2buy-resize-dynamic-cebdcaefgydgh6hu.z02.azurefd.net/dm2buy/".concat(imageName, ".jpg?width=500&height=500");
      } else {
        imageurl = product.productPhotos[0];
      }
    }

    return imageurl;
  };

  (0,react.useEffect)(function () {
    var urlPath = product.productPhotos && product.productPhotos[0] ? // eslint-disable-next-line no-undef
    new URL(product.productPhotos[0]).pathname : "";
    var extractedImageName = parseFileName(urlPath).name;
    setImageName(extractedImageName);
  }, [product.productPhotos]);

  var checkStock = function checkStock() {
    var stockAvailable = false;

    if (product.variantOptions && product.variantOptions.length) {
      product.variantOptions.forEach(function (variant) {
        if ((variant === null || variant === void 0 ? void 0 : variant.availableStock) > 0) {
          stockAvailable = true;
        }
      });
    } else {
      return product.availableStock;
    }

    return stockAvailable;
  }; // Calculate dynamic widths based on collection home usage


  var imageWidthClass = usedForCollectionhome ? "w-[calc((var(--max-width)/1.5)-50px)] h-[calc((var(--max-width)/1.5)-50px)]" : "w-[calc((100vw/2)-33px)] h-[calc((100vw/2)-33px)] md:w-[calc((520px/2)-33px)] md:h-[calc((520px/2)-33px)]";
  var itemWidthClass = usedForCollectionhome ? "max-w-[calc((var(--max-width)/1.5)-50px)] mb-3" : "max-w-[calc((100vw/2)-33px)] mb-8 md:max-w-[calc((520px/2)-33px)]";
  if (!product) return "";
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    href: "/product/".concat(product.id),
    className: "flex flex-col items-start justify-start ".concat(itemWidthClass),
    onClick: function onClick() {
      if (search) {
        setShouldSearchReopen(router.asPath);
      } else {
        setShouldSearchReopen(null);
      }

      router.push("/product/".concat(product.id));

      if (toggleDrawer) {
        toggleDrawer();
      }
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: product && (product === null || product === void 0 ? void 0 : product.productPhotos[0]) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "relative rounded-lg",
          children: [!checkStock(product) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "absolute z-10 flex h-[98%] w-full cursor-pointer items-center justify-center rounded-lg text-2xl font-bold text-[#ff3333]",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "m-0 p-0 tracking-[3px]",
              children: "SOLD"
            })
          }), !imageLoaded && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "rounded-lg ".concat(imageWidthClass),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((index_umd_default()), {
              className: "rounded-lg border",
              animationData: shimmer_namespaceObject || components_shimmer_namespaceObject,
              loop: true,
              autoplay: true,
              rendererSettings: {
                preserveAspectRatio: "xMidYMid slice"
              }
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(build.LazyLoadImage, {
            style: !imageLoaded ? {
              visibility: "hidden",
              height: "0px !important",
              width: "0px !important",
              zIndex: 1,
              position: "absolute"
            } : {
              cursor: "pointer"
            },
            onLoad: function onLoad() {
              setImageLoaded(true);
            },
            onError: function onError(e) {
              if (!fallbackSet) {
                // Handle image load error by setting a fallback URL
                e.target.src = "".concat(product === null || product === void 0 ? void 0 : product.productPhotos[0]);
                setFallbackSet(true);
              }
            },
            className: "rounded-lg object-cover ".concat(imageWidthClass, " max-w-[none]"),
            src: getImageUrl(imageName, cohort),
            unoptimized: "true",
            objectfit: "cover",
            alt: product.name
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex w-full flex-col py-1",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "mb-1 cursor-pointer text-base font-normal text-fontBackground opacity-70",
          children: product && /*#__PURE__*/(0,jsx_runtime.jsx)((lib_default()), {
            text: usedForCollectionhome ? product.name.length > 20 ? "".concat(product.name.substring(0, 20), "...") : product.name : product.name,
            maxLine: "2",
            ellipsis: "...",
            trimRight: true,
            basedOn: "letters"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "cursor-pointer text-base font-bold text-fontBackground",
          children: product && getProductPrice(product.price, product.mrp)
        })]
      })]
    })
  });
};

/* harmony default export */ var components_StoreItem = (StoreItem);

/***/ }),

/***/ 7486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _components_AppContainer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9117);
/* harmony import */ var _styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(214);
/* harmony import */ var _styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);





var reload = function reload() {
  window.location.reload();
};

var Error500Page = function Error500Page() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_components_AppContainer__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
      src: "/500.png",
      className: (_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2___default().title404),
      alt: "500 image"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
      className: (_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2___default().notFoundMessage),
      children: "We are over capacity! Please wait a moment and try again."
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
      onClick: reload,
      className: (_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2___default().notFoundHeadHome),
      children: "Refresh"
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (Error500Page);

/***/ })

}]);